import { TeContainer, TeDropdown, TeDropdownOption, TeToggle } from '@topcon/tuicl-react';
import { useState } from 'react';
import { getLibraryTheme, setLibraryTheme, TeToggleEvent } from '@topcon/tuicl';
import { TokensVariant } from '@topcon/design-system';

import i18n, { languages } from '../../i18n/i18next';

const DevSettings = () => {
  const [dark, setDark] = useState(getLibraryTheme() === TokensVariant.dark);

  const handleChangeLanguage = (value: string) => {
    i18n.changeLanguage(value);
  };

  const handleThemeChange = (e: TeToggleEvent) => {
    const { toggled } = e;
    setDark(toggled);
    setLibraryTheme(toggled ? TokensVariant.dark : TokensVariant.light);
    window.location.reload();
  };
  return (
    <TeContainer column>
      Settings
      <TeContainer>
        <TeDropdown persistent techange={(event) => handleChangeLanguage(event.value)}>
          {languages.map((language) => {
            return <TeDropdownOption key={language} value={language} text={language} />;
          })}
        </TeDropdown>
      </TeContainer>
      <TeContainer>
        <TeToggle toggled={dark} tetoggle={handleThemeChange} label="DARK MODE" />
      </TeContainer>
    </TeContainer>
  );
};

export default DevSettings;
